/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeAccordion,
  BaSeButton,
  BaSeDialogContext,
  BaSeHeading4,
  BaSeHeading5,
  BaSeHeading6,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
  BaSeToggler,
} from '@base/react';
import { format, parseISO } from 'date-fns';
import * as React from 'react';

import {
  RANGE_FIVE,
  RANGE_FOUR,
  RANGE_ONE,
  RANGE_SIX,
  RANGE_THREE,
  RANGE_TWO,
  useNotesRangeController,
} from '../../../../hooks/controllers/notes-range-controller';
import { useMessage } from '../../../../hooks/messages/useMessage';
import {
  ButtonBox,
  Content,
  HistoryBox,
  HistoryContent,
  HistoryDialogContent,
  HistoryDialogContentItem,
  HistoryDialogHeader,
  HistoryDialogNote,
  HistoryDialogRow,
  HistoryItem,
  HistoryItemCalibragem,
  Item,
  Separator,
} from './calibrate-notes-styled';
import { NotesRange } from './notes-range';

export const CalibrateNotes = () => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const { handleError, handleSuccess } = useMessage();
  const {
    getNotesRange,
    getHistory,
    getHistoryDetail,
    isValidCalibration,
    update,
    getStatusCalibration,
    updateStatusOfCalibration,
    getListStatusCalibration,
  } = useNotesRangeController();

  const [rangeOne, setRangeOne] = React.useState();
  const [rangeTwo, setRangeTwo] = React.useState();
  const [rangeThree, setRangeThree] = React.useState();
  const [rangeFour, setRangeFour] = React.useState();
  const [rangeFive, setRangeFive] = React.useState();
  const [rangeSix, setRangeSix] = React.useState();
  const [calibrationHistory, setCalibrationHistory] = React.useState();
  const [calibrationStatus, setCalibrationStatus] = React.useState();
  const [listCalibrationStatus, setListCalibrationStatus] = React.useState([]);

  const rangeMap = React.useMemo(
    () => [
      { range: rangeOne, onInputChange: setRangeOne },
      { range: rangeTwo, onInputChange: setRangeTwo },
      { range: rangeThree, onInputChange: setRangeThree },
      { range: rangeFour, onInputChange: setRangeFour },
      { range: rangeFive, onInputChange: setRangeFive },
      { range: rangeSix, onInputChange: setRangeSix },
    ],
    [rangeFour, rangeTwo, rangeThree, rangeSix, rangeFive, rangeOne],
  );

  const listaStatusCalibraiton = React.useCallback(() => {
    getListStatusCalibration()
      .then((response) => {
        setListCalibrationStatus(response);
      })
      .catch(() => {
        handleError('Erro ao buscar o histórico de calibragem.');
      });
  }, [getListStatusCalibration, handleError]);

  const showHistoryDialog = React.useCallback(
    (date, historyDetail) => {
      return showModal({
        actions: [],
        alignActions: 'center',
        size: 'large',
        title: () => (
          <HistoryDialogHeader>
            <BaSeHeading5 color={BaSeTheme.colors.institucionais.cinzaSebrae30}>
              Histórico de calibragem
            </BaSeHeading5>
            <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
              {historyDetail[0].userName} | {date}
            </BaSeSmall1>
          </HistoryDialogHeader>
        ),
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: () => (
          <HistoryDialogContent>
            {historyDetail?.map((item, index) => (
              <HistoryDialogRow key={index}>
                <HistoryDialogNote>
                  <BaSeParagraph isBold>
                    Nota: {item.rangeScoreCce.rangeScore}
                  </BaSeParagraph>
                </HistoryDialogNote>
                <HistoryDialogContentItem>
                  <BaSeParagraph isBold>Alteração:</BaSeParagraph>
                  <BaSeParagraph>
                    De {item.start} até {item.end}
                  </BaSeParagraph>
                </HistoryDialogContentItem>
                {index < historyDetail.length - 1 && <Separator />}
              </HistoryDialogRow>
            ))}
          </HistoryDialogContent>
        ),
      });
    },
    [showModal],
  );

  const updateStatusCalibration = React.useCallback(() => {
    updateStatusOfCalibration()
      .then((response) => {
        setCalibrationStatus(response.status);
      })
      .finally(() => listaStatusCalibraiton())
      .catch((e) => console.error(e));
  }, [listaStatusCalibraiton, updateStatusOfCalibration]);

  const ATIVAR_CALIBRAVEM = React.useMemo(
    () => [
      {
        title: 'Ativar calibragem',
        description: `Ao ser ativada, o sistema utilizará as notas Empretec conforme as notas retornadas da ferramenta de I.A. e parametrizadas nas faixas de enquadramento.
        `,
      },
      {
        title: 'Desativar calibragem',
        description:
          'Ao ser desativado, as notas Empretec serão calculadas diretamente pela ferramenta de I.A. e as notas não serão enquadradas por faixas.',
      },
    ],
    [],
  );

  const showModeCalibrationDialog = React.useCallback(() => {
    return showModal({
      actions: [
        {
          action: 'Sim',
          color: BaSeTheme.colors.institucionais.cinzaSebrae10,
        },
        'Não',
      ],
      alignActions: 'start',
      size: 'large',
      title: () => (
        <BaSeHeading4 isBold color={BaSeTheme.colors.gestao.cinza30}>
          {calibrationStatus
            ? ATIVAR_CALIBRAVEM[1].title
            : ATIVAR_CALIBRAVEM[0].title}
        </BaSeHeading4>
      ),
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      content: () => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 5,
            }}
          >
            <BaSeHeading4 color={BaSeTheme.colors.feedbackInterface.atencao55}>
              Atenção!
            </BaSeHeading4>
            <BaSeParagraph color={BaSeTheme.colors.gestao.cinza30}>
              {calibrationStatus
                ? 'Você está desativando a calibragem de notas.'
                : 'Você está ativando a calibragem de notas.'}
            </BaSeParagraph>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 15,
            }}
          >
            <BaSeParagraph color={BaSeTheme.colors.gestao.cinza30}>
              {calibrationStatus && ATIVAR_CALIBRAVEM[1].description}
            </BaSeParagraph>

            {calibrationStatus && (
              <BaSeParagraph color={BaSeTheme.colors.gestao.cinza30}>
                Tem certeza que deseja continuar?
              </BaSeParagraph>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 15,
            }}
          >
            <BaSeParagraph color={BaSeTheme.colors.gestao.cinza30}>
              {!calibrationStatus && ATIVAR_CALIBRAVEM[0].description}
            </BaSeParagraph>
            {!calibrationStatus && (
              <BaSeParagraph color={BaSeTheme.colors.gestao.cinza30}>
                É necessário que as mudanças de notas e faixas estejam alinhadas
                junto a Speck.
              </BaSeParagraph>
            )}

            {!calibrationStatus && (
              <BaSeParagraph color={BaSeTheme.colors.gestao.cinza30}>
                Tem certeza que esse alinhamento foi realizado e que deseja
                continuar?
              </BaSeParagraph>
            )}
          </div>
        </div>
      ),
      onChooseAction: (action) => {
        if (action === 'Sim') {
          updateStatusCalibration();
          return;
        }
      },
    });
  }, [
    ATIVAR_CALIBRAVEM,
    calibrationStatus,
    showModal,
    updateStatusCalibration,
  ]);

  const historyDetail = React.useCallback(
    (history) => {
      getHistoryDetail(history.ids).then((historyDetails) => {
        showHistoryDialog(history.date, historyDetails);
      });
    },
    [getHistoryDetail, showHistoryDialog],
  );

  const getCalibrationHistory = React.useCallback(() => {
    getHistory().then((history) => {
      setCalibrationHistory(history);
    });
  }, [getHistory]);

  const updateCalibration = React.useCallback(() => {
    if (!isValidCalibration(rangeMap)) {
      handleError(
        'Existe(m) faixa(s) onde o campo "De" é maior ou igual ao campo "Até"',
      );
      return;
    }

    update(rangeMap.map((item) => item.range))
      .then(() => {
        getCalibrationHistory();
        handleSuccess('Calibragem realizada com sucesso');
      })
      .catch(() => handleError('Erro ao tentar realizar calibragem das notas'));
  }, [
    getCalibrationHistory,
    handleError,
    handleSuccess,
    isValidCalibration,
    rangeMap,
    update,
  ]);

  const updateRangeMap = React.useCallback((range) => {
    const map = {
      [RANGE_ONE]: setRangeOne,
      [RANGE_TWO]: setRangeTwo,
      [RANGE_THREE]: setRangeThree,
      [RANGE_FOUR]: setRangeFour,
      [RANGE_FIVE]: setRangeFive,
      [RANGE_SIX]: setRangeSix,
    };

    return map[range.name](range);
  }, []);

  React.useEffect(() => {
    getNotesRange().then((notesRange) => {
      notesRange.forEach((range) => {
        updateRangeMap(range);
      });
    });
  }, [getNotesRange, updateRangeMap]);

  const getStatusOfCalibration = React.useCallback(() => {
    getStatusCalibration().then(({ status }) => {
      setCalibrationStatus(status);
    });
  }, [getStatusCalibration]);

  React.useEffect(() => {
    getCalibrationHistory();
    getStatusOfCalibration();
    listaStatusCalibraiton();
  }, [getCalibrationHistory, getStatusOfCalibration, listaStatusCalibraiton]);

  return (
    <Content>
      <br />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <BaSeHeading4
          isBold
          color={BaSeTheme.colors.institucionais.cinzaSebrae30}
        >
          Calibragem de notas
        </BaSeHeading4>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <BaSeHeading6
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae30}
          >
            Desativado
          </BaSeHeading6>
          <BaSeToggler
            onChange={() => showModeCalibrationDialog()}
            value={calibrationStatus}
          />
          <BaSeHeading6
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae30}
          >
            Ativado
          </BaSeHeading6>
        </div>
      </div>
      <Separator />
      <BaSeHeading4 color={BaSeTheme.colors.institucionais.cinzaSebrae30}>
        Selecione a nota
      </BaSeHeading4>
      {rangeMap.map((item, index) => (
        <NotesRange
          key={index}
          calibrationStatus={calibrationStatus}
          track={item.range?.name}
          start={item.range?.start}
          end={item.range?.end}
          rangeScore={item.range?.rangeScore}
          onInputChange={item.onInputChange}
          onInputChangePreviousNote={rangeMap[index - 1]?.onInputChange}
          onInputChangeNextNote={rangeMap[index + 1]?.onInputChange}
        />
      ))}
      <ButtonBox>
        <BaSeButton
          value="Atualizar calibragem"
          onClick={updateCalibration}
          color={BaSeTheme.colors.institucionais.cinzaSebrae10}
        />
      </ButtonBox>
      <div>
        <BaSeAccordion
          startOpen={0}
          options={[
            {
              title: 'Histórico de status',
              content: (
                <div>
                  {listCalibrationStatus.map((item, index) => (
                    <HistoryContent style={{ padding: '18px 0' }} key={item.id}>
                      <HistoryItem
                        style={{
                          borderBottom: '1px solid #cecece',
                        }}
                      >
                        <Item>
                          <BaSeHeading6
                            isBold
                            color={
                              BaSeTheme.colors.institucionais.cinzaSebrae30
                            }
                          >
                            Data:
                          </BaSeHeading6>
                          <BaSeParagraph
                            color={
                              BaSeTheme.colors.institucionais.cinzaSebrae45
                            }
                          >
                            {format(
                              parseISO(item.changeDate),
                              'dd/MM/yyy HH:mm:ss',
                            )}
                          </BaSeParagraph>
                        </Item>
                        <Item>
                          <BaSeHeading6
                            isBold
                            color={
                              BaSeTheme.colors.institucionais.cinzaSebrae30
                            }
                          >
                            Status:
                          </BaSeHeading6>
                          <BaSeParagraph
                            color={
                              BaSeTheme.colors.institucionais.cinzaSebrae45
                            }
                          >
                            {item.status ? 'Ativado' : 'Desativado'}
                          </BaSeParagraph>
                        </Item>
                        <Item>
                          <BaSeHeading6
                            isBold
                            color={
                              BaSeTheme.colors.institucionais.cinzaSebrae30
                            }
                          >
                            Usuário:
                          </BaSeHeading6>
                          <BaSeParagraph
                            color={
                              BaSeTheme.colors.institucionais.cinzaSebrae45
                            }
                          >
                            {item.user.name}
                          </BaSeParagraph>
                        </Item>
                      </HistoryItem>
                    </HistoryContent>
                  ))}
                </div>
              ),
            },
          ]}
        />

        {calibrationHistory?.length > 0 && (
          <HistoryBox>
            <BaSeAccordion
              startOpen={0}
              options={[
                {
                  title: 'Ver histórico de calibragem',
                  content: (
                    <div>
                      {calibrationHistory?.map((history, index) => (
                        <HistoryContent key={index}>
                          <HistoryItemCalibragem
                            onClick={() => historyDetail(history)}
                          >
                            <BaSeHeading6
                              isBold
                              color={
                                BaSeTheme.colors.institucionais.cinzaSebrae30
                              }
                            >
                              Data:
                            </BaSeHeading6>
                            <BaSeParagraph
                              color={
                                BaSeTheme.colors.institucionais.cinzaSebrae45
                              }
                            >
                              {history.date}
                            </BaSeParagraph>
                          </HistoryItemCalibragem>
                          {index < calibrationHistory.length - 1 && (
                            <Separator />
                          )}
                        </HistoryContent>
                      ))}
                    </div>
                  ),
                },
              ]}
            />
          </HistoryBox>
        )}
      </div>
    </Content>
  );
};
